import {useMemo, useState, useEffect} from 'react';
import {useJsonFetch} from '@sail/data';
import {AnyNotification} from 'mkt-ssr/lib/notifications/types';
import {DEFAULT_PREFIX, usePrefix} from 'mkt-ssr/lib/globalization';

export type NotificationsAPIResponse = Array<AnyNotification>;

const NOTIFICATIONS_ENDPOINT_BASE = '/notifications?as=json';

const MOCK_NOTIFICATIONS: Array<AnyNotification> = [
  {id: 'CookieSettingsNotification', data: {}},
  {
    id: 'MismatchedCountryDetectorNotification',
    data: {
      activeCountry: 'US',
      desiredCountry: 'AE',
      overrideLocale: 'en',
      dismissedCookieName: 'cookie_consent',
      bodyMessage: `You're viewing our website for Mexico, but it looks like you're in the United States.`,
      linkMessage: 'Switch to the United States site',
    },
  },
];

// Flip this flag for testing in development
const USE_MOCK_NOTIFICATIONS = false;

function useMockNotifications(): Array<AnyNotification> {
  const [notifications, setNotifications] = useState<Array<AnyNotification>>(
    [],
  );
  useEffect(() => {
    setTimeout(() => {
      setNotifications(MOCK_NOTIFICATIONS);
    }, 100);
  }, []);
  return notifications;
}

export function useRealNotifications(): Array<AnyNotification> {
  const prefix = usePrefix();

  const {data} = useJsonFetch<NotificationsAPIResponse>(
    // NB: This is not a pattern we want to replicate, but
    // we cannot pipe this through `createRoute()` because that
    // generates an object, which this method cannot handle, so
    // we manually construct it here. Realistically we should make
    // this endpoint take this as an argument/param, not based on
    // the localization segment, but it's pretty entrenched
    // there at this point.
    prefix === DEFAULT_PREFIX.prefix
      ? NOTIFICATIONS_ENDPOINT_BASE
      : `/${prefix}${NOTIFICATIONS_ENDPOINT_BASE}`,
  );

  return useMemo(() => data || [], [data]);
}

export function useNotifications(): Array<AnyNotification> {
  if (USE_MOCK_NOTIFICATIONS) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useMockNotifications();
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useRealNotifications();
}
